import { useEffect, useState } from 'react'
import vars from '@/assets/styles/vars'

const TEXT_INPUT = /^(text|search|email|tel|url|password|number)$/

function isTextEntry(el) {
  if (!el || el.nodeType !== 1) return false
  if (el.isContentEditable) return true
  if (el.tagName === 'TEXTAREA') return true
  if (el.tagName !== 'INPUT') return false
  return TEXT_INPUT.test((el.getAttribute('type') || 'text').toLowerCase())
}

export default function useMobileKeyboard(enabled = true) {
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!enabled) return undefined

    const mobileQuery = window.matchMedia(`(max-width: ${vars.breakpoints.tablet}px)`)
    let maxHeight = window.visualViewport?.height || window.innerHeight
    let trackedWidth = window.innerWidth
    let awaitingKeyboard = false
    let timer

    const sync = () => {
      const viewport = window.visualViewport
      const height = viewport?.height || window.innerHeight
      const width = window.innerWidth

      if (Math.abs(width - trackedWidth) > 80) {
        trackedWidth = width
        maxHeight = height
      } else if (height > maxHeight) {
        maxHeight = height
      }

      const mobile = mobileQuery.matches
      const keyboardOpen = mobile && maxHeight - height > 140
      const typing = mobile && isTextEntry(document.activeElement)

      if (keyboardOpen) awaitingKeyboard = false
      setOpen(keyboardOpen || (typing && awaitingKeyboard))
    }

    const onFocusIn = () => {
      if (!mobileQuery.matches || !isTextEntry(document.activeElement)) {
        sync()
        return
      }
      awaitingKeyboard = true
      setOpen(true)
      clearTimeout(timer)
      timer = setTimeout(() => {
        awaitingKeyboard = false
        sync()
      }, 500)
    }

    const onFocusOut = () => {
      clearTimeout(timer)
      timer = setTimeout(() => {
        awaitingKeyboard = false
        sync()
      }, 80)
    }

    document.addEventListener('focusin', onFocusIn)
    document.addEventListener('focusout', onFocusOut)
    window.visualViewport?.addEventListener('resize', sync)
    if (mobileQuery.addEventListener) mobileQuery.addEventListener('change', sync)
    else mobileQuery.addListener(sync)

    return () => {
      clearTimeout(timer)
      document.removeEventListener('focusin', onFocusIn)
      document.removeEventListener('focusout', onFocusOut)
      window.visualViewport?.removeEventListener('resize', sync)
      if (mobileQuery.removeEventListener) mobileQuery.removeEventListener('change', sync)
      else mobileQuery.removeListener(sync)
    }
  }, [enabled])

  return open
}
